import { useEffect, useState } from "react";

// Hook simple basado en window.matchMedia. Devuelve true si el viewport es <
// breakpoint (default 768px = Bootstrap md). Útil para render condicional
// del SideBar (drawer en mobile, columna fija en desktop).
//
// Uso:
//   const isMobile = useIsMobile();
//   return isMobile ? <Drawer /> : <FixedSidebar />;
//
// Nota: el render inicial (antes del primer effect) usa matchMedia sincrónico
// para evitar flash desktop→mobile en pantallas chicas.
export default function useIsMobile(maxWidthPx = 767) {
  const query = `(max-width: ${maxWidthPx}px)`;

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    // Compat: addEventListener moderno + addListener legacy iOS Safari < 14
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}
